export const QA_NAME_VIEWING_PROFILE_OUTCOME = 'viewingProfileOutcome'
